export default __webpack_public_path__ + "static/media/TA-Img4.4092e41f.png";